<template>
  <div class="form">
    <div class="commit-info">
      <section class="basic-info">
        <div class="title">通知详情</div>
        <div class="detial">{{ notifyText }}</div>
      </section>
      <section class="product-info" v-show="title !== ''">
        <div @click="goToDetial()" class="title">{{ title }}</div>
        <div class="info">
          <div class="pic">
            <div
              class="pic-core"
              @click="goToDetial()"
              :style="{ backgroundImage: 'url(' + $setPicSize(info.infoPic) + ')' }"
            />
          </div>
          <div class="left-info">
            <div class="left-info-title">
              商品标题：<span>{{ info.infoTitle }}</span>
            </div>
            <div class="left-info-title" v-if="info.infoPrice">
              商品价格：<span>{{ info.infoPrice }}</span>
            </div>
            <div class="left-info-title" v-if="info.sellerNickName">
              卖家昵称：<span>{{ info.sellerNickName }}</span>
            </div>
            <div class="left-info-title" v-if="info.buyerNickName">
              买家昵称：<span>{{ info.buyerNickName }}</span>
            </div>
            <div class="left-info-title" v-if="info.orderTime">
              下单时间：<span>{{ info.orderTime }}</span>
            </div>
            <div class="left-info-title">
              保证金ID：<span class="copy-link" :data-clipboard-text="info.depositId">{{
                info.depositId
              }}</span>
            </div>
            <div class="left-info-title" v-if="info.orderAmount">
              订单支付金额：<span>{{ info.orderAmount }}</span>
            </div>
            <div class="left-info-title">
              保证金金额：<span>{{ info.depositAmount }}</span>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="form-bottom" @click="closePage()">
      <div class="form-bottom-text">返回</div>
    </div>
  </div>
</template>

<script>
import ClipboardJS from 'clipboard'
import native from '@zz-common/native-adapter'
import setPicSize from '@zz-app/setPicSize'
import { Toast } from '@zz-common/zz-ui'
import { getdepositnotify } from '@api/resourceApi'
import copy from '../../lib/copy'
import { lego } from '@zz-common/lego'
import { toast } from '../../native'
import { queryParams, getCookie } from '../../lib/utils'
const query = queryParams()

export default {
  name: 'uploadExample',
  data() {
    return {
      type: query.type || this.$route.query.type,
      infoId: query.infoId || this.$route.query.infoId,
      orderId: query.orderId || this.$route.query.orderId,
      depositId: query.depositId || this.$route.query.depositId,
      info: {
        notifyType: '',
        depositAmount: '',
        depositId: '',
        infoTitle: '',
        orderTime: '',
        orderAmount: '',
        buyerNickName: '',
        infoPic: '',
        sellerNickName: '',
        infoPrice: ''
      },
      title: '',
      notifyText: ''
    }
  },
  computed: {},
  methods: {
    init() {
      this.loading = true
      const params = {}
      if (this.infoId) params.infoId = this.infoId
      if (this.orderId) params.orderId = this.orderId
      if (this.depositId) params.depositId = this.depositId
      if (this.type) params.type = this.type
      return getdepositnotify({ ...params })
        .then((respData) => {
          console.log('---respData', respData)
          this.loading = false
          const { status = '', msg = '', data = {} } = respData
          if (+status !== 0) {
            return toast({
              msg: msg || '获取申诉信息错误',
              style: '2'
            })
          }
          this.info = { ...data }
          this.title = data.title
          this.notifyText = data.notifyText
          lego.send({
            pagetype: 'ZZUP_BONDINFO',
            actiontype: 'PAGE_SHOW',
            backup: {
              type: this.type,
              notifyType: this.info.notifyType,
              uid: getCookie('uid')
            }
          })
          return respData
        })
        .catch((err) => {
          this.code = ''
          toast({
            msg: err.message || '获取申诉信息错误',
            style: '2'
          })
        })
    },
    goToDetial() {
      lego.send({
        pagetype: 'ZZUP_BONDINFO',
        actiontype: 'CLICK',
        backup: {
          type: this.type,
          notifyType: this.info.notifyType,
          uid: getCookie('uid')
        }
      })
      if (this.info.notifyType === '1') {
        native.wrap('enterDetail')({
          infoId: this.infoId,
          from: 'm'
        })
      } else if (this.info.notifyType === '2') {
        native.wrap('enterOrderDetail')({
          orderId: this.orderId,
          from: 'm'
        })
      }
    },
    $setPicSize(url) {
      return setPicSize(url)
    },
    copyValue() {
      console.log('this.info.depositId', this.info.depositId)
      copy('.depositId')
      Toast('保证金ID复制成功')
    },
    closePage() {
      native.close()
    }
  },
  mounted() {
    native.setTitle({
      title: '保证金通知'
    })
    this.init()
    const clipboard = new ClipboardJS('.copy-link')
    clipboard.on('success', function(e) {
      console.info('Action:', e.action)
      console.info('Text:', e.text)
      console.info('Trigger:', e.trigger)
      Toast(`保证金ID ${e.text} 复制成功`)
      e.clearSelection()
    })

    clipboard.on('error', function(_e) {
      Toast('不支持自动复制，请手动复制')
    })
  },
  components: {
    // zIcon: Icon,
    // Toast
  },
  beforeRouteEnter(_to, _from, next) {
    next((_vm) => {
      native.wrap('resetRightAllButton')()
    })
  }
}
</script>

<style scoped lang="less">
  @import './ViewInfo.less';
</style>
